import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
import { FlexContainer } from './PredicateRow';

// Styles
import { PredicateRowIndent } from '../../../../../../../../common/styles/mixins';

const Element = styled.p`
    font-weight: 700;
    margin: 0.25rem 0 0.25rem 0.5rem;
    z-index: 1;
    ${PredicateRowIndent}
`;

export const PredicateConjunction = ({ children, nestedLevel, ...rest }) => {
    return (
        <FlexContainer previewOnly>
            <Element {...rest} indent={nestedLevel}>
                {children}
            </Element>
        </FlexContainer>
    );
};

export default PredicateConjunction;

PredicateConjunction.propTypes = {
    children: PropTypes.node,
    nestedLevel: PropTypes.number
};
